module.exports = __webpack_public_path__ + "static/media/camel.a4f4279a.jpg";